export const calendar = {
    finyearStart: () => {
        return new Date('2019-04-01');
    },
    finyearEnd: () => {
        return new Date('2020-03-31');
    },
    today: () => {
        return new Date();
    },
};



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/lib/calendar.ts